export default "__VITE_ASSET__BmK16Pfp__"